/*
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-10-25 21:40:02
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-26 10:24:03
 */
// import Home from "@/views/home/home";
import center from '@/views/personal/center';
import { ControlLayout } from '@/components/layout';

const normalRoutes = [
	{
		path: '/personal',
		component: ControlLayout,
		meta: { title: '个人中心' },
		redirect: '/personal/center',
		children: [
			{
				path: 'center',
				component: center,
				name: '个人中心',
				meta: { title: '个人中心', useTemplate: true, showBread: true },
			},
		],
	},
];
export default normalRoutes;
